import { c as _c } from "react/compiler-runtime";
import { ProjectListItemCardMobile } from "@components/project/project-list-item-card-mobile";
import { useCompanyId } from "@context-providers/company-id-provider";
import { Box } from "@mui-wrapper";
import { useProjectMenuOptions } from "@pages/projects/use-project-menu-options";
import { generateProjectDetailsRoute } from "@router/router-helper";
/**
 * @returns A card with information of the passed project.
 */
export function ProjectsMapListItem(t0) {
  const $ = _c(22);
  const {
    project,
    goTo,
    onHoverChange,
    isHighlighted,
    sortBy
  } = t0;
  const companyId = useCompanyId();
  let t1;
  if ($[0] !== goTo) {
    t1 = {
      contextType: "project-map-view",
      goTo
    };
    $[0] = goTo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const menuItems = useProjectMenuOptions(t1);
  let t2;
  if ($[2] !== onHoverChange || $[3] !== project.id) {
    t2 = () => onHoverChange?.(project.id);
    $[2] = onHoverChange;
    $[3] = project.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onHoverChange) {
    t3 = () => onHoverChange?.(null);
    $[5] = onHoverChange;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      marginY: "1.5px"
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== companyId || $[9] !== project.id) {
    t5 = generateProjectDetailsRoute(companyId, project.id);
    $[8] = companyId;
    $[9] = project.id;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== goTo || $[12] !== isHighlighted || $[13] !== menuItems || $[14] !== project || $[15] !== sortBy || $[16] !== t5) {
    t6 = <ProjectListItemCardMobile project={project} sortBy={sortBy} contextType="project-map-view" href={t5} menuItems={menuItems} variant="outlined" isSelected={isHighlighted} goTo={goTo} />;
    $[11] = goTo;
    $[12] = isHighlighted;
    $[13] = menuItems;
    $[14] = project;
    $[15] = sortBy;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t2 || $[19] !== t3 || $[20] !== t6) {
    t7 = <Box onMouseEnter={t2} onMouseLeave={t3} sx={t4}>{t6}</Box>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}